export const notRequired = () => [
    {
        required: false
    }
];

export default notRequired;
